import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asacontact',
  templateUrl: './asacontact.component.html',
  styleUrls: ['./asacontact.component.scss']
})
export class AsacontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
